import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: 'rgba(166, 107, 255, 0.22)',
} as const

export const resources = {
  loginBg: '/images/novaris/login/login-bg.webp',
  logo: '/images/novaris/login/storlyn-logo.svg',
  novel: '/images/novaris/login/storlyn-novel.svg',
  facebookIcon: '/images/novaris/login/icon-facebook-logo.png',
  googleIcon: '/images/novaris/login/icon-google-logo-storlyn.svg',
  appleIcon: '/images/novaris/login/icon-apple-logo-storlyn.svg',
  emailIcon: '/images/novaris/login/icon-email.png',
  emailCodeIcon: '/images/novaris/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive({
    ...loginCommonConfig.texts,
    brandTitle: 'Welcome to Novaris',
    brandSubtitle: 'Dive into bold fantasy, romance, and midnight favorites.',
    siteName: 'Novaris',
  }),
}
